<div class="view e11-min-h-full e11-flex e11-flex-col e11-justify-center e11-py-6 e11-px-6">
  <div class="sm:e11-mx-auto sm:e11-w-full sm:e11-max-w-md">
    <div class="e11-w-full e11-flex e11-justify-center">
      <img [src]="logoUrl" class="e11-h-24" alt="Cnect" />
    </div>
    <h1 class="e11-text-skin-primary-accent e11-mb-4 e11-text-center">
      {{ 'Signing you in' | translate }}
    </h1>
  </div>

  <div class="sm:e11-mx-auto sm:e11-w-full sm:e11-max-w-md">
    <e11-panel [bgOpacity]="90">
      <div class="e11-w-full e11-flex e11-flex-col e11-items-center e11-text-center">
        <cnect-loader-link [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></cnect-loader-link>
        <p class="e11-mt-4">{{ 'Please wait while we complete your sign-in.' | translate }}</p>
      </div>
    </e11-panel>
  </div>
</div>
